import { render, staticRenderFns } from "./CorregirTestWorkspace.vue?vue&type=template&id=26d8a888"
import script from "./CorregirTestWorkspace.vue?vue&type=script&lang=js"
export * from "./CorregirTestWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports